import React, { useState } from "react";
import "./Footer.scss";
import { Container } from "@mui/material";
import { Link } from "react-router-dom";
import { useAppContext } from "../../helpers/AppContext";
import { Facebook, Instagram, LinkedIn, Mail, WhatsApp, YouTube } from "@mui/icons-material";

import baseURL from "../../config/config";

const Footer = () => {
  const { handleScroll, handleRegisterFormClick } = useAppContext();
  const [showDropdown, setShowDropdown] = useState(false);

  const navItems = [
    { label: "Home", path: baseURL },
    { to: "/read-aloud", label: "Read Aloud" },
    { to: "/textbook-help", label: "Textbook Help" },
    { to: "/classroom-hub", label: "Classroom Hub" },
    // { label: "Performance", path: `${baseURL}/performance` },
    { label: "Register", path: "/", onClick: () => setShowDropdown(!showDropdown) },
    { label: "About Us", path: `${baseURL}/about` },
    { label: "Contact Us", path: `${baseURL}/contact` },
  ];


  const dropdownItems = [
    { label: "ReadAloud", path: "/read-aloud" },
    { label: "TextbookHelp", path: "/textbook-help" },
    { label: "ClassroomHub", path: "/classroom-hub" },
  ];

  const socialMediaLinks = [
    { icon: <Instagram />, label: "Instagram", url: "https://www.instagram.com/praccel.app/" },
    { icon: <YouTube />, label: "YouTube", url: "https://www.youtube.com/@PraccelApp" },
    { icon: <Facebook />, label: "Facebook", url: "https://www.facebook.com/Praccel/" },
    { icon: <LinkedIn />, label: "LinkedIn", url: "https://www.linkedin.com/company/praccel/" },
  ];

  return (
    <footer className="footer">
      <Container maxWidth="xl">
        <div className="content">
          <div className="logo">
            <h2>Paleru Technologies Pvt. Ltd.</h2>
            <p>Mangalore, India.</p>
            <p>
              <a href="mailto:karthik@praccel.com" target="_blank" rel="noopener noreferrer">
                <Mail /> {" "} karthik@praccel.com
              </a>
            </p>
            <p>
              <a href="https://wa.me/918951621660" target="_blank" rel="noopener noreferrer">
                <WhatsApp /> {" "} +91 8951621660
              </a>
            </p>
          </div>

          <nav className="nav">
            <ul>
              {navItems.map((item, index) => (
                <li key={index} onClick={item.onClick || handleScroll} className="relative">
                  <Link to={item.path}>{item.label}</Link>

                  {/* Dropdown menu */}
                  {item.label === "Register" && showDropdown && (
                    <ul className="dropdown absolute left-0 top-full mt-2 bg-[#0a57ff] text-black rounded shadow-lg w-48 z-50">
                      {dropdownItems.map((dropItem, idx) => (
                        <li key={idx} className="hover:bg-[#031844c6] px-4 py-2">
                          <Link to={dropItem.path}>{dropItem.label}</Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </nav>

          <div>
            {socialMediaLinks.map((link, index) => (
              <p key={index}>
                <a href={link.url} target="_blank" rel="noopener noreferrer">
                  {link.icon} {link.label}
                </a>
              </p>
            ))}
          </div>
        </div>

        <div className="bottom">
          <p>&copy; Paleru Technologies Pvt. Ltd. {new Date().getFullYear()}. All rights reserved.</p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
